import React from "react";
import {Box, Container, Typography, List, ListItem, ListItemIcon, ListItemText} from "@mui/material";
import CheckIcon from '@mui/icons-material/Check';

const MaliDanismanlik = () => {
    return (
        <Container maxWidth="md" sx={{py: 5}}>
            <Box textAlign="center" mb={4}>
                <Typography variant="h4" fontWeight="bold" gutterBottom>
                    Mali Stratejinizde Rehberlik Ediyor, Finansal Hedeflere Ulaşmanızı Sağlıyoruz.
                </Typography>
                <Typography variant="subtitle1" color="textSecondary">
                    Biz; vergi yükümlülüklerinizi en aza indirmek ve mevzuata uygunluğunuzu sağlamak
                    adına uzman vergi danışmanlarımızla birlikte çalışıyoruz.
                </Typography>
            </Box>

            <Typography variant="body2" color="textPrimary" paragraph>
                Vergi beyannamelerinin düzenlenmesi ve sürekli vergi danışmanlığı ile işletmenizin finansal sağlığını
                koruyoruz. Her türlü vergi danışmanlığı, mali hukuk danışmanlığı, uluslararası vergi hizmetleri
                danışmanlığı, teşvik uygulama ve destek danışmanlığı gibi her türlü mali konularda danışmanlık hizmeti
                profesyonel ekibimiz tarafından verilmektedir.
            </Typography>

            <Typography variant="h6" fontWeight="bold" gutterBottom>
                Vergi Danışmanlığı
            </Typography>

            <Typography variant="body2" color="textPrimary" paragraph>
                Günümüzde işletmeler, faaliyetlerine yönelik strateji geliştirme, mevzuata uyum, risk yönetimi ve iş
                planı uygulama konularına odaklanmakta, bu nedenle günümüzün karmaşık vergi uygulamalarına yönelik
                çözümler geliştirmede sorun yaşayabilmektedir.
            </Typography>

            <Typography variant="body2" color="textPrimary" paragraph>
                Bu doğrultuda bünyemizde yer alan konusunda uzman profesyonel arkadaşlarımızla beraber,
                mükelleflerimizin doğru zamanda doğru kararlar alabilmelerini sağlamak için, vergisel konularda
                danışmanlık hizmeti vermekteyiz.
            </Typography>

            <Typography variant="h8" fontWeight="bold" gutterBottom>
                Bu kapsamda vergi danışmanlığı hizmeti verdiğimiz konular şunlardır:
            </Typography>
            <List>
                <ListItem>
                    <ListItemIcon><CheckIcon color="success"/></ListItemIcon>
                    <ListItemText primary="Kurumlar Vergisi ve Gelir Vergisi" primaryTypographyProps={{
                        fontWeight: 'medium',
                        variant: 'body2',
                    }}/>
                </ListItem>
                <ListItem>
                    <ListItemIcon><CheckIcon color="success"/></ListItemIcon>
                    <ListItemText primary="Stopaj yoluyla alınan vergiler" primaryTypographyProps={{
                        fontWeight: 'medium',
                        variant: 'body2',
                    }}/>
                </ListItem>
                <ListItem>
                    <ListItemIcon><CheckIcon color="success"/></ListItemIcon>
                    <ListItemText primary="KDV, ÖTV, Damga Vergisi, BSMV ve KKDF gibi işlemlerden alınan vergiler"
                                  primaryTypographyProps={{
                                      fontWeight: 'medium',
                                      variant: 'body2',
                                  }}/>
                </ListItem>
                <ListItem>
                    <ListItemIcon><CheckIcon color="success"/></ListItemIcon>
                    <ListItemText primary="Veraset ve İntikal Vergisi ve Emlak Vergisi devir işlemleri"
                                  primaryTypographyProps={{
                                      fontWeight: 'medium',
                                      variant: 'body2',
                                  }}/>
                </ListItem>
                <ListItem>
                    <ListItemIcon><CheckIcon color="success"/></ListItemIcon>
                    <ListItemText primary="Çifte Vergilendirmeyi Önleme Anlaşmaları" primaryTypographyProps={{
                        fontWeight: 'medium',
                        variant: 'body2',
                    }}/>
                </ListItem>
                <ListItem>
                    <ListItemIcon><CheckIcon color="success"/></ListItemIcon>
                    <ListItemText primary="KDV planlaması ve yurt içi/yurt dışı KDV iadesi işlemleri"
                                  primaryTypographyProps={{
                                      fontWeight: 'medium',
                                      variant: 'body2',
                                  }}/>
                </ListItem>
                <ListItem>
                    <ListItemIcon><CheckIcon color="success"/></ListItemIcon>
                    <ListItemText
                        primary="Lisans, royalti, teknik servis, gider paylaşımı, bayilik vb. sözleşmeler ile hisse devir sözleşmeleri ve uluslararası sözleşmelerin vergisel yükümlülükler açısından analizi ve değerlendirilmesi,"
                        primaryTypographyProps={{
                            fontWeight: 'medium',
                            variant: 'body2',
                        }}/>
                </ListItem>
                <ListItem>
                    <ListItemIcon><CheckIcon color="success"/></ListItemIcon>
                    <ListItemText primary="Transfer fiyatlandırması danışmanlık hizmeti," primaryTypographyProps={{
                        fontWeight: 'medium',
                        variant: 'body2',
                    }}/>
                </ListItem>
                <ListItem>
                    <ListItemIcon><CheckIcon color="success"/></ListItemIcon>
                    <ListItemText
                        primary="Mevzuattaki güncel değişikliklerin ve uygulamaların sirküler yoluyla bildirilmesi."
                        primaryTypographyProps={{
                            fontWeight: 'medium',
                            variant: 'body2',
                        }}/>
                </ListItem>
            </List>

            <Typography variant="h6" fontWeight="bold" gutterBottom>
                Yönetim Danışmanlığı
            </Typography>

            <Typography variant="body2" color="textPrimary" paragraph>
                Şirketlerin faaliyet sonuçlarını şeffaf bir şekilde gösterecek muhasebe sisteminin kurulması, kontrol
                edilmesi ve karar alma aşamasında yöneticilere yardımcı olacak raporların üretilmesi konusunda uzman
                kadromuz ve modern tekniklerle hizmet vermeye hazırız.
            </Typography>

            <List>
                <ListItem>
                    <ListItemIcon><CheckIcon color="success"/></ListItemIcon>
                    <ListItemText primary="Muhasebe Sisteminin Kurulması ve Kontrol Edilmesi," primaryTypographyProps={{
                        fontWeight: 'medium',
                        variant: 'body2',
                    }}/>
                </ListItem>
                <ListItem>
                    <ListItemIcon><CheckIcon color="success"/></ListItemIcon>
                    <ListItemText primary="Süreçlerin Denetimi ve Sistem Analizi," primaryTypographyProps={{
                        fontWeight: 'medium',
                        variant: 'body2',
                    }}/>
                </ListItem>
                <ListItem>
                    <ListItemIcon><CheckIcon color="success"/></ListItemIcon>
                    <ListItemText primary="Yönetici ve Personel Eğitimi," primaryTypographyProps={{
                        fontWeight: 'medium',
                        variant: 'body2',
                    }}/>
                </ListItem>
                <ListItem>
                    <ListItemIcon><CheckIcon color="success"/></ListItemIcon>
                    <ListItemText primary="Mali Analiz ve Raporlama," primaryTypographyProps={{
                        fontWeight: 'medium',
                        variant: 'body2',
                    }}/>
                </ListItem>
                <ListItem>
                    <ListItemIcon><CheckIcon color="success"/></ListItemIcon>
                    <ListItemText primary="Maliyet Sistemi kurulması," primaryTypographyProps={{
                        fontWeight: 'medium',
                        variant: 'body2',
                    }}/>
                </ListItem>
                <ListItem>
                    <ListItemIcon><CheckIcon color="success"/></ListItemIcon>
                    <ListItemText primary="Bütçe uygulamaları" primaryTypographyProps={{
                        fontWeight: 'medium',
                        variant: 'body2',
                    }}/>
                </ListItem>
            </List>
        </Container>
    );
};

export default MaliDanismanlik;
